import DOMPurify from "dompurify";
import MegaBall from "./MegaBall";
import TicketDigits from "./TicketDigits";

class CardMobile extends React.Component {
  constructor(props) {
    super(props);
    this.getDataKey = this.getDataKey.bind(this);
    this.loopDigits = this.loopDigits.bind(this);
    this.MegaBallDataKey = this.MegaBallDataKey.bind(this);
  }

  loopDigits(card) {
    let lotteryArray = [];
    for (let index = 1; index <= card; index++) {
      lotteryArray.push(index);
    }
    return lotteryArray;
  }

  getDataKey(event) {
    let UID;
    event.target
      .getAttribute("id")
      .split("-")
      .map((item) => (Number(item) !== NaN ? (UID = Number(item)) : null));
    this.props.updateTicketDigitSelcted(UID, event.target.innerText);
  }

  MegaBallDataKey(event) {
    let UID;

    event.target
      .getAttribute("id")
      .split("-")
      .map((item) => (Number(item) !== NaN ? (UID = Number(item)) : null));

    this.props.updateMegaSelectedMobile(UID, event.target.innerText);
  }

  render() {
    let lotterySelect = this.props.current_lottery,
      selected_digits_mobile_click = this.props.selected_digits_mobile_click;
    const t = this.props.t;
    return (
      <>
        <div className="card__mobile">
          {/* main number component */}
          <div className="card__dynamic-buttons">
            <div
              className="card__quick-pick-3-lines"
              title="quick pick lottery numbers"
              onClick={this.props.quickPick}
              id="quick-pick-3"
              data-id="quick-pick-3"
            >
              3 {DOMPurify.sanitize(t("m_QPHdr"))} <br />
              <span className="card__cost-info">
                {DOMPurify.sanitize(t("m_QPinfo"))}{" "}
                {Number(
                  this.props.current_lottery.price_per_ticket * 3
                ).toFixed(2)}
                €
              </span>
            </div>
            <div
              className="card__quick-pick-6-lines"
              title="clear selected lottery numbers"
              onClick={this.props.quickPick}
              id="quick-pick-6"
              data-id="quick-pick-6"
            >
              6 {DOMPurify.sanitize(t("m_QPHdr"))} <br />
              <span className="card__cost-info">
                {DOMPurify.sanitize(t("m_QPinfo"))}{" "}
                {Number(
                  this.props.current_lottery.price_per_ticket * 6
                ).toFixed(2)}
                €
              </span>
            </div>
          </div>
          {this.loopDigits(selected_digits_mobile_click).map((display, id) => (
            <div
              className={`card__edit-lines ${
                this.props.mobile_editable ? "display" : "none"
              }`}
              key={id}
              id={`edit-${id}`}
              onClick={this.props.editLineFn}
            >
              <div className="card__single-line">
                {" "}
                {this.props.cardData[id].selected_digits.length >
                lotterySelect.maximum_digits
                  ? this.props.cardData[id].selected_digits.map((item, index) =>
                      !Array.isArray(item) ? (
                        <div className="card__text-upper" key={index}>
                          {item}
                        </div>
                      ) : (
                        item.map((mega_item, mega_index) => (
                          <div
                            className="card__text-upper-Mega"
                            key={mega_index}
                          >
                            {mega_item}
                          </div>
                        ))
                      )
                    )
                  : `${DOMPurify.sanitize(t("m_editLine"))}`}{" "}
              </div>
              <button
                className="card__quick-pick-single"
                onClick={this.props.quickPickEdit}
              >
                {DOMPurify.sanitize(t("cardQuickPick"))}
              </button>
              <button
                className="card__delete-mobile"
                onClick={this.props.deleteMobile}
              >
                x
              </button>
            </div>
          ))}

          <div
            className={` card-mobiled ${
              this.props.mobile_stats ? "mobile" : " "
            }`}
          >
            {/* main number component */}
            <div className="card__number">
              {/* selected numbers array */}
              <div className="card__info" title="select a maximum of 6 numbers">
                {" "}
                {this.props.cardData[selected_digits_mobile_click]
                  .selected_digits.length !== 0 &&
                selected_digits_mobile_click == 0
                  ? this.props.cardData[
                      selected_digits_mobile_click
                    ].selected_digits.map((item, index) =>
                      !Array.isArray(item) ? (
                        <div className="card__text-upper" key={index}>
                          {item}
                        </div>
                      ) : (
                        item.map((mega_item, mega_index) => (
                          <div
                            className="card__text-upper-Mega"
                            key={mega_index}
                          >
                            {mega_item}
                          </div>
                        ))
                      )
                    )
                  : selected_digits_mobile_click > 0
                  ? this.props.cardData[
                      selected_digits_mobile_click
                    ].selected_digits.map((item, index) =>
                      !Array.isArray(item) ? (
                        <div className="card__text-upper" key={index}>
                          {item}
                        </div>
                      ) : (
                        item.map((mega_item, mega_index) => (
                          <div
                            className="card__text-upper-Mega"
                            key={mega_index}
                          >
                            {mega_item}
                          </div>
                        ))
                      )
                    )
                  : `${DOMPurify.sanitize(t("cardPickerMsg1"))} ${
                      this.props.current_lottery.maximum_digits
                    } ${DOMPurify.sanitize(t("cardPickerMsg2"))}`}
              </div>
              <div className="card__dynamic-buttons">
                <div
                  className="card__quick-pick"
                  title="quick pick lottery numbers"
                  onClick={this.props.quickPickSingle}
                >
                  {DOMPurify.sanitize(t("cardQuickPick"))}{" "}
                </div>
                <div
                  className="card__clear"
                  title="clear selected lottery numbers"
                  onClick={this.props.clear}
                >
                  {DOMPurify.sanitize(t("cardClear"))}{" "}
                </div>
                <div
                  className={`card__submit ${
                    this.props.activateSubmitButton ? "" : ""
                  }`}
                  title="quick pick lottery numbers"
                  onClick={this.props.submitMobile}
                >
                  {DOMPurify.sanitize(t("m_submitButton"))}{" "}
                </div>
              </div>

              {/* load ticket digits component */}
              <div className="card__wrap-ticket">
                <TicketDigits
                  lottery={lotterySelect}
                  getDataKey={this.getDataKey}
                />
              </div>
            </div>

            {/* megaball components */}
            <div className="card__wrap">
              <div className="card__number-Mega-mobile">
                <div className="card__heading">
                  <div className="card__info" title="choose one lucky number">
                    {DOMPurify.sanitize(t("cardPickerMsg1"))} 2{" "}
                    {DOMPurify.sanitize(t("cardPickerMsg2"))}
                  </div>
                </div>

                {/* load extra/megaball number component */}
                <MegaBall
                  lottery={lotterySelect}
                  MegaBallDataKey={this.MegaBallDataKey}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default CardMobile;
